class HtmlPageService {
    scrollElement(jQuerySelector, pixelsFromTop, continueWith) {
        if (!pixelsFromTop)
            pixelsFromTop = 0;

        var navbar = $("#header");
        var navbarHeight = navbar.length === 0 ? 0 : navbar.height();
        var element = $(jQuerySelector);

        if (element.length === 0) return; //if we have no elements -> do nothing 
        var domElement = element[0];

        if (window.top)
            window.top.postMessage("scroll into view: " + jQuerySelector, "*");

        //if element is already visible -> do nothing (prevent from scrolling up/down an already visible element)
        if (this.isScrolledIntoView(domElement)) return;
        
        var offset = $(jQuerySelector).offset();
        $("body,html").animate({
                scrollTop: offset.top - pixelsFromTop - navbarHeight,
                scrollLeft: offset.left
            }, 500, continueWith);
    }

    isScrolledIntoView(elem) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $(elem).offset().top;
        var elemBottom = elemTop + $(elem).height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }
}

export default new HtmlPageService();